exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-footer[data-v-291ab490]{text-align:right;margin-top:10px}.el-form-item[data-v-291ab490]{margin-bottom:15px}", ""]);

// exports
